import { WSQueryConfig } from "@ws-react-query";

import { useWSQuery } from "../../helpers";
import { QUERY_SIGNED_DOCUMENT } from "../keys";
import { getSignedDocument } from "../../../services/signedDocuments";
import { ISignedDocumentResponse } from "@wingspanhq/signed-documents/dist/lib/interfaces";

export const useQuerySignedDocument = (
  id: string,
  queryConfig?: WSQueryConfig<ISignedDocumentResponse, unknown>
) =>
  useWSQuery([QUERY_SIGNED_DOCUMENT, id], () => getSignedDocument(id), {
    retry: false,
    refetchOnMount: false,
    ...queryConfig
  });
